document.addEventListener('DOMContentLoaded', () => {
  const MAX_HEIGHT_MOBILE = 100;
  const MOBILE_BREAKPOINT = 749;
  const descriptionSelector = '[data-block-type="description"] .prose'; 
  const descriptionElement = document.querySelector(descriptionSelector);

  if (!descriptionElement) {
    return; // Esce se non trova la descrizione
  }

  // Definiamo i testi
  const readMoreText = 'Leggi tutto';
  const readLessText = 'Leggi meno';

  // Funzione per creare il link (se non esiste)
  function createToggleLink() {
    if (descriptionElement.scrollHeight <= MAX_HEIGHT_MOBILE) {
      return; // Testo corto, non serve il link
    }
    
    let toggleLink = descriptionElement.parentNode.querySelector('.custom-read-more-link');
    if (toggleLink) {
      return; // Già inizializzato
    }

    toggleLink = document.createElement('span');
    toggleLink.classList.add('custom-read-more-link');
    toggleLink.innerText = readMoreText; // Testo iniziale
    descriptionElement.parentNode.insertBefore(toggleLink, descriptionElement.nextSibling);

    if (window.innerWidth <= MOBILE_BREAKPOINT) {
        descriptionElement.classList.add('description-truncated');
    }

    // Aggiungi il listener UNA SOLA VOLTA
    toggleLink.addEventListener('click', () => {
      const isCurrentlyTruncated = descriptionElement.classList.contains('description-truncated');

      descriptionElement.classList.toggle('description-truncated');

      if (isCurrentlyTruncated) {
        // Era troncato, ora è espanso -> Mostra "Leggi meno"
        toggleLink.innerText = readLessText;
      } else {
        // Era espanso, ora è troncato -> Mostra "Leggi tutto"
        toggleLink.innerText = readMoreText; // <-- ECCO LA CORREZIONE!
        
        // Scrolla in alto per far rivedere l'inizio del blocco
        descriptionElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  // Funzione per aggiornare la visibilità (al caricamento e al resize)
  function updateLinkVisibility() {
    const toggleLink = descriptionElement.parentNode.querySelector('.custom-read-more-link');
    if (!toggleLink) {
        if (descriptionElement.scrollHeight > MAX_HEIGHT_MOBILE) {
            createToggleLink();
        }
        return;
    }

    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      if (descriptionElement.scrollHeight > MAX_HEIGHT_MOBILE) {
        toggleLink.style.display = 'inline-block';
      } else {
        toggleLink.style.display = 'none';
        descriptionElement.classList.remove('description-truncated');
      }
    } else {
      toggleLink.style.display = 'none';
      descriptionElement.classList.remove('description-truncated');
    }
  }

  // --- ESECUZIONE ---
  createToggleLink();
  updateLinkVisibility();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateLinkVisibility, 250);
  });
});